import {
    EnumCheckCredentialsResult,
    EnumInfoUTypes,
    EnumLoginSecureKeyTypes,
    EnumMFAMethods,
    EnumNotificationDeliveryOptions,
    EnumNotificationStatuses,
    EnumPopupShowStatuses,
    HistoryEventTypesEnum,
    EnumSystemOptionDataTypes, EnumUserLoginStatus, EnumLocalizationTypes, EnumNotificationTemplateEditingMode, EnumPrintingType,
    EnumLogLevel
} from '@core/framework/sysenums.enum';

export class BaseState { }
export class BaseEntity {
    EntryID: number;
    TypeName?: string;
}

export class BaseResponse {
    IsSuccess: boolean;
    ResponseCode: number;
    ResponseMessage: string;
    ResponseExtendedMessage: string;
}

export class KeyValueEntity extends BaseEntity {
    Key: string;
    Value: string;
}

export class GenericListEntity extends BaseEntity {
    constructor(
        public Value?: string,
        public Text?: string,
        public Description?: string,
        public SortOrder?: number
    ) { super(); }
}


//Response types prototypes - for single entity, list of entities, and single data field response
export class BaseEntityResponse<TEntity extends BaseEntity> extends BaseResponse { Entity: TEntity; }
export class BaseEntitiesResponse<TEntity extends BaseEntity> extends BaseResponse { Entities: TEntity[] }
export class BaseDataResponse<TData> extends BaseResponse { Data: TData; }

export class CredentialsCheckResponse {
    public CredentialID: number;
    public CredentialType: number;
    public CheckResult: EnumCheckCredentialsResult;
    public CheckResultMessage: string;
    public UserName: string;
}


export class CredentialActivityStatus extends BaseEntity {
    DisplayUserName: string;
    LastUseDate: Date;
    IsOnline: boolean;
}


export class LoginParams extends BaseEntity {
    public UserName: string
    public SecureKey: string
    public SecureKeyType: EnumLoginSecureKeyTypes;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Language: string;
    public NewPassword: string;
    public TaxNumber: string;
    public ClientFingerprint: string;
}

export class PasswordRecoveryParams extends BaseEntity {
    public UserName: string
    public Address: string;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Token: string;
    public Language: string;
    public NewPassword: string;

}

export class CompanyInfo extends BaseEntity {
    public DecimalSeparator: string
    public ThousandsSeparator: string

    public NumberGeneral: string
    public NumberPercent: string
    public NumberPrice: string
    public NumberQuantity: string
    public NumberRate: string
    public NumberSum: string

    public DateFormatShort: string
    public DateFormatLong: string
    public DateFormatCompact: string
    public DateFormatFull: string
    public TimeFormatLong: string
    public TimeFormatShort: string
    public DefaultVatGroupCode: string;

    public CurrencyLocal: string
    public CurrencySystem: string

    public VatPercent: number;
    public IsVatLiable: boolean;

    public ServerVersion: string;
    public ClientVersion: string;
    public SBOVersion: string;
    public LocalizationType: EnumLocalizationTypes;
}

export class ClientException extends BaseEntity {
    Type: string
    Message: string
    StackTrace: string

    Device: string;
    DeviceType: string
    Browser: string
    BrowserVersion: string
    OS: string
    OSVersion: string
}

export class DataGroupInfo extends BaseEntity {
    constructor(
        public Name: string,
        public Value: string,
        public TotalRows = 0,
    ) { super(); }
}

export class ItemPriceInfo extends BaseEntity {
    Price: number;
    DiscountPercent: number;
    Currency: string;
}


export class Media extends BaseEntity {
    ImageBase64: string;
    ImageBytes: number[];
    VideoBytes: number[];
    VideoDataUrl: any;
}

export class WebAPICredential extends BaseEntity {
    UserName: string;
    Password: string;
    Type: number;
    IsActive: boolean = true;
    IsPendingWelcome: boolean;
    MFAMethod: EnumMFAMethods;
    IsRestrictByIP: boolean;
    IsExcludeFromMFA: boolean;

    WebAPIAllowedIPs: WebAPIAllowedIP[];
}

export class WebAPIAllowedIP extends BaseEntity {
    CredentialID: number;
    IPRangeStart: string;
    IPRangeEnd: string;
}

export class WebAPICredentialInfo extends BaseEntity {
    UserName: string;
    Type: number;
    IsActive: boolean;
    IsPendingWelcome: boolean;
    MFAMethod: EnumMFAMethods
    IsRestrictByIP: boolean;
    IsExcludeFromMFA: boolean;
    IsLockedOut: boolean;
    IsSupportedUserWelcome: boolean;

    WebAPIAllowedIPs: WebAPIAllowedIP[];
}

export class CredentialExternalInfo extends BaseEntity {
    DisplayUserName: string;
    DisplayUserDescription: string;
    Phone: string;
    Email: string;
    AdditionalInfo1: string;
    AdditionalInfo2: string;
    AdditionalInfo3: string;
    AdditionalInfo4: string;
    AdditionalInfo5: string;
    IsActive: true;
    Type: number;
}

export class AttachedFile extends BaseEntity {
    public Name: string;
    public Extension: string;
    public NewFile: File;
    public Size: number;
    public IconStyle: string;
    public IsDisplayedAsImage: boolean;
    public Date: Date;
    public IsAllowDeleteForcely: boolean;
}

export class UploadFile extends BaseEntity {
    public Name: string;
    public Type: string;
    public Data: any;
    public Buffer: ArrayBuffer;
    public File: File;
}

export class CommonSettingEntity extends BaseEntity {
    public Name: string;
    public Description: string;
}

export class NotificationView extends BaseEntity {
    public CreatedBy: number;
    public CreatedDate: Date;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Status: EnumNotificationStatuses;
    public Subject: string;
    public FromAddress: string;
    public FromDisplayAddress: string;
    public Address: string;
    public CCAddress: string;
    public BccAddress: string;
    public NotificationTemplateID: number;
    public ReadDate: Date;
    public SharedFileUID: string;
    public TargetCredentialName: string;
    public CreatedByName: string;
    public UserName: string;
    public NotificationTemplateName: string;
    public IsAutomatic: boolean;
    public IsDeleted: boolean;
}

export class Notification extends BaseEntity {
    public CreatedBy: number;
    public CreatedDate: Date;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Status: EnumNotificationStatuses;
    public Subject: string;
    public Body: string;
    public FromAddress: string;
    public FromDisplayAddress: string;
    public Address: string;
    public CCAddress: string;
    public BccAddress: string;
    public ExternalReferenceID: any;
    public NotificationTemplateID: number;
    public ReadDate: Date;
    public IsRead: boolean;
    public TargetCredentialID: number;
    public SharedFileUID: string;
    public TargetCredentialName: string;
    public CreatedByName: string;
    public NotificationTemplateName: string;
    public FailureDescription: string;
    public RelatedObjectType: string;
    public RelatedObjectID: number;
    public PopupShowStatus: EnumPopupShowStatuses;
    public IsAutomatic: boolean;
    public IsDeleted: boolean;
}

export class NotificationListParams extends BaseEntity {
    public Address: string;
    public UntilDate: Date;
    public FromDate: Date;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Template: string;
    public NotificationDispatchID: number;
}

export class NotificationDispatchListParams extends BaseEntity {
    public FromDate: Date;
    public UntilDate: Date;
    public DeliveryMethod: EnumNotificationDeliveryOptions;
    public Statuses: EnumNotificationStatuses[];
    public TemplateID: number;
    public CreatedByName: string
    public NotificationTemplateName: string;
}

export class SendNotificationDispatchParams extends BaseEntity
{
    public DeliveryMethod: EnumNotificationDeliveryOptions;
    public NotificationTemplateID: number;
    public Name: string;
    public Description: string;
    public Subject: string;
    public Body: string;
    public RecipientIDs: number[];
    public Header: string;
    public IsSimplifiedHtmlBodyEdit: boolean;
}

export class NotificationServer extends BaseEntity {
    public SMTPServer: string;
    public SMTPPort: number;
    public SMTPUserName: string;
    public SMTPPassword: string;
    public SMTPUseSSL: boolean;
    public SMSEndpoint: string;
    public SMSUserName: string;
    public SMSPassword: string;
    public SMSToken: string;
    public SMSEndPointIsInforU: EnumInfoUTypes;
}

export class NotificationTemplate extends BaseEntity {
    public Name: string;
    public Language: string;
    public Subject: string;
    public HTMLBody: string;
    public FromEmailDisplay: string;
    public FromEmail: string;
    public FromPhone: string;
    public SMSBody: string;
    public WhatsAppBody: string;
    public PushMessageBody: string;
    public NotificationServerID: number;
    public IsUserCustomTemplate: boolean;
    public EntityBindingPageType: EnumPrintingType;
    public EditingMode: EnumNotificationTemplateEditingMode;
    public EntityType: string;
    public PageName: string;
    public CrystalTemplateFileID: number;
    public IsSharePdf: boolean;
    public FileNameFormat: string;
    public CrystalTemplateFileView: FileView = new FileView;
}

export class NotificationDispatch extends BaseEntity {
    public CreatedBy: number;
    public CreatedDate: Date;
    public Status: EnumNotificationStatuses;
    public DeliveryMethod: EnumNotificationDeliveryOptions;
    public NotificationTemplateID: number;
    public Name: string;
    public Description: string;
    public CanCancel: boolean;
}

export class FileView extends BaseEntity {
    public FileData: number[] = [];
    public Name: string;
    public FullName: string;
    public Extension: string;
    public ContentType: string;
}

export class NotificationTemplateView extends BaseEntity {
    public Name: string;
    public Language: string;
}

export class NotificationTemplateListView extends BaseEntity {
    public Name: string;
    public Language: string;
    public IsSupportSharing: boolean;
    public IsSupportEmail: boolean;
    public IsSupportSMS: boolean;
    public IsSupportWhatsapp: boolean;
    public EntityType: string;
    public PageName: string;
    public EditingMode: EnumNotificationTemplateEditingMode;
    public EntityBindingPageType: EnumPrintingType;
}

export class RenderedTemplate extends BaseEntity {
    public Subject: string;
    public Body: string;
    public CcAddress: string;
    public BccAddress: string;
}

export class SharingInformation extends BaseEntity {
    public Subject: string;
    public Body: string;
    public PrefixBody: string;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public EntityEntryID: number;
    public Entities: BaseEntity[] = [];
    public NotificationTempalteID: number;
    public AttachmentUniqueID: number;
    public Address: string;
    public CcAddress: string;
    public BccAddress: string;
}

export class PushMessageListParams extends BaseEntity {
    public IsLoadAllNotifications: boolean;
}

export class NotificationTestParams extends BaseEntity {
    public NotificationServerID: number;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public FromAddress: string;
    public Address: string;
}

export class CredentialLoginParams extends BaseEntity {
    public DateFrom: Date;
    public DateTo: Date;
    public Status: EnumUserLoginStatus;
    public CredentialType: number;
    public CredentialID: number;
}

export class CredentialLogin extends BaseEntity {
    public ClientUserName: string;
    public CredentialType: number;
    public StartDate: Date;
    public LastUseDate: Date;
    public Status: EnumUserLoginStatus;
    public ClientIPAddress: string;
    public ImpersonateByID: number;
    public CredentialID: number;
}

export class CredentialCheckResponse extends BaseEntity {
    public IsExists: boolean;
    public HasPhone: boolean;
    public HasEmail: boolean;
}

export class SaveCredentialsParams extends BaseEntity {
    public CredentialID: number;
    public UserName: string;
    public Password: string;
    public Type: number;
    public IsActive: boolean;
    public MFAMethod: EnumMFAMethods;
    public IsRestrictByIP: boolean;
    public IsExcludeFromMFA: boolean;
    public WebAPIAllowedIPs: WebAPIAllowedIP[];
}

export class SystemOptionEntity extends BaseEntity {
    public OptionName: string;
    public Value: string;
    public SectionInfo: string;
    public IsServer: boolean;
    public IsClient: boolean;
    public ModuleName: string;

    public SectionIndex: number;
    public ValueNumber: number;
    public ValueBoolean: boolean;
    public IsDeleted: boolean;
    public DataType: EnumSystemOptionDataTypes;
    public DefaultIsClient: boolean;
}

export class CredentialType extends BaseEntity {
    public Value: number;
    public Text: string;
}

export class WebAPIRequestListParams extends BaseEntity {
    CredentialID: number;
    ModuleName: string
    Controller: string;
    Action: string;
    DateFrom: Date;
    DateTo: Date;
}

export class WebAPIRequest extends BaseEntity {
    SessionID: number;
    DateTime: Date;
    Duration: number;
    Controller: string;
    Action: string;
    ModuleName: string;
    Method: string;
    QueryString: string;
    Body: string;
    Response: string;
    StatusCode: number;
}

export class HistoryChangesSet extends BaseEntity {
    public CreatedDate: Date;
    public CreatedBy: number;
    public Changeset: number;
    public CredentialName: string;
    public HistoryChanges: HistoryChangeDetails[];
    public HistoryLineChanges: HistoryChangeDetails[];
}

export class HistoryChangeDetails extends BaseEntity {
    public Action: HistoryEventTypesEnum;
    public FieldName: string;
    public NewValue: string;
    public OldValue: string;
    public EntityType: string;
    public EntityEntryID: number;
    public EntityLineID: number;
    public Name: string;
}

export class WebAPILoginResponse extends BaseEntity {
    public CheckResult: EnumCheckCredentialsResult;
    public CheckResultMessage: string;
    public SessionID: string;
    public CredentialID: number;
    public CredentialType: number;
    public DisplayUserName: string;
    public DisplayUserDescription: string;
    public UserInfo: any[] = [];
}

export class SystemCredentialInfo extends BaseEntity {
    UserName: string;
    Type: number;
    IsPendingWelcome: boolean;
    MFAMethod: EnumMFAMethods;
    IsRestrictByIP: boolean;
    IsExcludeFromMFA: boolean;
    IsLockedOut: boolean;
    IsSupportedUserWelcome: boolean;
    WebAPIAllowedIPs: WebAPIAllowedIP[];

    DisplayUserName: string;
    DisplayUserDescription: string;
    Phone: string;
    Email: string;
    AdditionalInfo1: string;
    AdditionalInfo2: string;
    AdditionalInfo3: string;
    AdditionalInfo4: string;
    AdditionalInfo5: string;
    IsActive: boolean;
    LastUseDate: Date;
}

export class AdditionalInfoMetadata {
    Caption: string;
}

export class CredentialsCheckerMetadata extends BaseEntity {
    AdditionalInfo1: AdditionalInfoMetadata;
    AdditionalInfo2: AdditionalInfoMetadata;
    AdditionalInfo3: AdditionalInfoMetadata;
    AdditionalInfo4: AdditionalInfoMetadata;
    AdditionalInfo5: AdditionalInfoMetadata;
}

export class CreateCredentialsParams extends BaseEntity {
    public DeliveryOption: number;
    public UserCreationOption: number;
    public Language: string;
    public CredentialsForCreation: CredentialExternalInfo[];
}

export class SystemCredentialParams extends BaseEntity {
    public CredentialType: number;
    public CredentialID: number;
    public IsActive: boolean;
    public IsPendingWelcome: boolean;
    public IsLockedOut: boolean;
    public CredentialFilter: number;
}

export class DataEditorView extends BaseEntity {
    public ObjectName: string;
    public DViewsDuration: number;
    public XViewsDuration: number;
    public DViewsDBName: string;
    public XViewsBName: string;
    public IsValid: boolean;
    public IsOverriden: boolean;
    public Error?: string;
}

export class RemoteRequest extends BaseEntity {
    SessionID: number;
    DateTime: Date;
    Duration: number;
    Controller: string;
    Action: string;
    ModuleName: string;
    Method: string;
    QueryString: string;
    Body: string;
    Response: string;
    StatusCode: number;
}

export class RemoteRequestListParams extends BaseEntity {
    Controllers?: string[];
    Actions?: string[];
    Methods?: string[];
    Statuses?: number[];
    public DateFrom: Date;
    public DateTo: Date;
}

export class Log extends BaseEntity {
    Level: EnumLogLevel;
    Title: string;
    Body: string;
    RelatedObjectType: string;
    RelatedObjectID: string;
}

export class LogParams extends BaseEntity {
    RelatedObjectType: string;
    RelatedObjectID: number;
    Level: EnumLogLevel;
}